// extracted by mini-css-extract-plugin
export default {"title":"News_title__FLMOz"};